<!--首页估价记录-->
<template>
  <div class="assess-record-contain">
    <div class="title">估价次数: {{ total }}</div>
    <div class="record-p">
      <div class="tb-head">
        <div class="tb-item1">总价</div>
        <div class="tb-item1">估价</div>
        <div class="tb-item2">手机号</div>
        <div class="tb-item3">时间</div>
      </div>
      <div class="tb-body beauty-scroll" v-infinite-scroll="load" :infinite-scroll-disabled="disabled" :infinite-scroll-distance="10">
        <div v-for="item in list" :key="item.id" class="list-item">
          <div class="tb-item1">{{ item.prices }}</div>
          <div class="tb-item1">{{ item.price }}</div>
          <div class="tb-item2">{{ item.username.slice(0, 3) + '****' + item.username.slice(-4) }}</div>
          <div class="tb-item3">{{ item.createtime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserCollection } from '@/api/person.js'
export default {
  props: {
    steamId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [],
      page: 1,
      limit: 20,
      loading: false,
      isFinished: false,
      total: 0
    }
  },
  computed: {
    disabled() {
      return this.loading || this.isFinished
    }
  },
  watch: {
    steamId: {
      handler: function (val) {
        this.load()
      },
      immediate: true
    }
  },
  methods: {
    reload() {
      this.page = 1
      this.isFinished = false
      this.load()
    },
    load() {
      if (this.steamId != '' && !this.isFinished && !this.loading) {
        this.loading = true
        getUserCollection({
          steam_id: this.steamId,
          page: this.page,
          number: this.limit
        }).then((res) => {
          if (res.code == '0') {
            this.isFinished = true
            this.loading = true
          } else {
            this.total = res.total || 0
            if (this.page == 1) {
              this.list = []
              this.page = this.page + 1
            }
            this.list = this.list.concat(res.data)
            if (res.current_page == res.last_page) {
              this.isFinished = true
            }
            this.loading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.assess-record-contain {
  width: 250px;
  height: 100%;
  padding: 5px 5px;
  box-sizing: border-box;
  background: rgba(183, 233, 246, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;

  .title {
    font-size: 18px;
    color: #fff;
    text-align: center;
    margin-bottom: 5px;
  }
  .record-p {
    width: 100%;
    height: calc(100% - 23px);
    .tb-head {
      font-size: 12px;
      color: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .tb-item1 {
        width: 19%;
        text-align: center;
      }
      .tb-item2 {
        width: 32%;
        text-align: center;
      }
      .tb-item3 {
        width: 30%;
        text-align: center;
      }
    }
    .tb-body {
      height: calc(100% - 12px);
      overflow-y: auto;
      width: 100%;
      .list-item {
        font-size: 12px;
        color: #fff;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .tb-item1 {
          width: 19%;
          text-align: center;
        }
        .tb-item2 {
          width: 32%;
          text-align: center;
        }
        .tb-item3 {
          width: 30%;
          text-align: center;
        }
      }
    }
  }
}

.beauty-scroll{
  scrollbar-color: #565656;
  scrollbar-width: thin;
  -ms-overflow-style:none;
  position: relative;
  overflow: auto;
}
.beauty-scroll::-webkit-scrollbar{
  width: 5px;
  height: 5px;
}
.beauty-scroll::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #565656;
}
.beauty-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0);
  border-radius: 3px;
  background: #ffffff00;
}
</style>
